<template>
  <div>
    <section>
      <div class="content">
        <div class="header">
          <h1>Secure top IT talent</h1>
          <img class="triangles" src="/img/other/Triangles_outlined.png" alt="triangles" />
          <img class="trianglesTwo" src="/img/other/Triangles_desktop.png" alt="triangles" />
        </div>
        <div class="list-content">
          <h4>Your one-stop solution for IT talent acquisition</h4>
          <ul class="list-unstyled">
            <li>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="27"
                height="21"
                viewBox="0 0 27 21"
                fill="none"
              >
                <path
                  d="M7.03577 20.8809C5.07368 13.571 2.95978 6.60417 0.678887 0.0148491C9.29698 2.47351 17.9652 4.70815 26.7654 6.75503C20.0183 11.8122 13.4489 16.5787 7.03577 20.8809Z"
                  fill="#F05C00"
                />
              </svg>
              Choose from our range of professional services, including headhunting, in-depth
              qualification, programming tests, and more
            </li>
            <li>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="27"
                height="21"
                viewBox="0 0 27 21"
                fill="none"
              >
                <path
                  d="M7.03577 20.8809C5.07368 13.571 2.95978 6.60417 0.678887 0.0148491C9.29698 2.47351 17.9652 4.70815 26.7654 6.75503C20.0183 11.8122 13.4489 16.5787 7.03577 20.8809Z"
                  fill="#F05C00"
                />
              </svg>
              Pay only for results — our fees are primarily success-based
            </li>
            <li>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="27"
                height="21"
                viewBox="0 0 27 21"
                fill="none"
              >
                <path
                  d="M7.03577 20.8809C5.07368 13.571 2.95978 6.60417 0.678887 0.0148491C9.29698 2.47351 17.9652 4.70815 26.7654 6.75503C20.0183 11.8122 13.4489 16.5787 7.03577 20.8809Z"
                  fill="#F05C00"
                />
              </svg>
              Hiring freelancers instead? Access vetted candidates in your time zone through our
              Freelancing Network
            </li>
          </ul>
        </div>
      </div>
      <div class="content-form">
        <form @submit.prevent="getCaptcha" v-if="user.step === 1" class="form">
          <div class="title">
            <svgHelper name="logoGray"></svgHelper>
            <h3>
              Start hiring now -<br />
              it's quick and easy!
            </h3>
            <span>Sign up with email</span>
          </div>

          <div class="form-floating">
            <input
              v-model="user.email"
              type="email"
              class="form-control"
              id="floatingInput"
              placeholder="name@example.com"
            />
            <label for="floatingInput">Corporate email</label>
          </div>

          <div class="form-check">
            <input
              type="checkbox"
              v-model="user.privacy"
              class="form-check-input"
              id="exampleCheck1"
            />
            <label
              style="text-transform: none!important;"
              class="form-check-label"
              for="exampleCheck1"
              >I agree to Jobshark's
              <router-link target="_blank" :to="{ name: 'integrity' }"
                >Integrity policy</router-link
              >
              and
              <router-link target="_blank" :to="{ name: 'new-conditions' }"
                >User conditions</router-link
              ></label
            >
          </div>
          <div class="form-footer">
            <div class="d-grid">
              <button
                :disabled="isSubmitDisabled"
                @click="getCaptcha"
                class="btn btn-primary"
                type="button"
              >
                <div>
                  <div v-if="isLoading" class="spinner-border" role="status">
                    <span class="visually-hidden">Loading...</span>
                  </div>
                  SIGN UP
                </div>
              </button>
            </div>
            <div class="contact">
              <div class="account">
                Already have an account? <router-link :to="{ name: 'home' }">Log in</router-link>
              </div>
            </div>
          </div>
        </form>

        <form @submit.prevent="verifyEmail" v-if="user.step === 2" class="form">
          <div class="title">
            <svgHelper name="logoGray"></svgHelper>
            <h3 class="mb-3">Verify your email address</h3>
            <p>Please confirm your email address by entering the six digit verification code.</p>
          </div>
          <div class="form-floating">
            <input
              required
              v-model="user.code"
              type="text"
              class="form-control"
              id="vercode"
              placeholder="Verification code"
              autocomplete="off"
            />
            <label for="vercode">Verification code</label>
          </div>

          <div class="form-footer">
            <div class="d-grid">
              <button
                :disabled="isLoading"
                @click="verifyEmail"
                class="btn btn-primary"
                type="button"
              >
                <div>
                  <div v-if="isLoading" class="spinner-border" role="status">
                    <span class="visually-hidden">Loading...</span>
                  </div>
                  Verify email
                </div>
              </button>
            </div>
            <div class="new-code">
              Didn't receive the code? <br />
              <span @click="sendNewCode">Send code again to {{ user.email }}</span
              ><br />
              <span @click="changeEmail">Change email address</span>
            </div>
          </div>
        </form>

        <form
          @submit.prevent="completeProfile"
          v-if="user.step === 3 || user.step === 4"
          class="form"
          id="complete-profile"
        >
          <div class="title">
            <svgHelper name="logoGray"></svgHelper>
            <h3>Complete your profile</h3>
          </div>

          <div v-if="user.step === 3">
            <div class="form-floating required">
              <input
                v-model="user.company"
                type="text"
                class="form-control"
                id="company"
                placeholder="Company"
                required
              />
              <label for="company">Company</label>
            </div>

            <div class="mb-3 select-model">
              <v-select
                @input="fetchCitisByCountryId"
                id="country"
                v-model="user.country"
                label="name"
                :options="newCountryList"
                placeholder="Select country"
                @search="fetchCountries"
                autocomplete="off"
              ></v-select>
            </div>

            <div class="form-floating required">
              <input
                v-model="user.address"
                type="text"
                class="form-control"
                id="street-address"
                placeholder="Street address"
                required
              />
              <label for="street-address">Street address</label>
            </div>

            <div class="row">
              <div class="col-md-5">
                <div class="form-floating required">
                  <input
                    v-model="user.postal"
                    type="text"
                    class="form-control"
                    id="postal-code"
                    placeholder="Postal code"
                  />
                  <label for="postal-code">Postal code</label>
                </div>
              </div>
              <div class="col-md-7">
                <div class="mb-3 select-model new-city-model">
                  <v-select
                    ref="citySelect"
                    id="city"
                    v-model="user.city"
                    label="name"
                    :options="newCityList"
                    :clearable="false"
                    placeholder="Select city"
                    @search="fetchCities"
                    @open="onSelectOpen"
                    autocomplete="off"
                    :autoscroll="false"
                  ></v-select>
                </div>
              </div>
            </div>
          </div>

          <div v-if="user.step === 4">
            <div class="form-floating required">
              <input
                v-model="user.firstName"
                type="text"
                class="form-control"
                id="first-name"
                placeholder="First name"
                required
              />
              <label for="first-name">First name</label>
            </div>

            <div class="form-floating required">
              <input
                v-model="user.lastName"
                type="text"
                class="form-control"
                id="last-name"
                placeholder="Last name"
              />
              <label for="last-name">Last name</label>
            </div>

            <div class="row">
              <div class="col-md-6">
                <div class="mb-3 select-model no-hor">
                  <v-select
                    id="country-code"
                    @input="addCountryCode(user.countryCode)"
                    v-model="user.countryCode"
                    label="name"
                    :options="formattedCountries"
                    :clearable="false"
                    placeholder="Country code"
                  ></v-select>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-floating required">
                  <input
                    v-model="user.phone"
                    type="text"
                    class="form-control"
                    id="phone"
                    placeholder="Phone"
                  />
                  <label for="Phone">Phone</label>
                </div>
              </div>
            </div>
            <div class="form-floating">
              <v-select
                ref="tzSelect"
                placeholder="Select Timezone"
                v-model="user.timeZone"
                :options="tzOptions"
                :clearable="false"
                :reduce="zone => zone"
                :filterable="false"
                label="utc_timezone"
                @search="onTzSearch"
                @open="onTzOpen"
              >
                <template #option="{ utc_timezone }">
                  {{ utc_timezone }}
                </template>
                <template #selected-option="{ utc_timezone }">
                  {{ utc_timezone }}
                </template>
              </v-select>
              <label for="role"></label>
              <!--               <v-select
                placeholder="Select Timezone"
                v-model="user.timeZone"
                :options="getTimeZones"
                :clearable="false"
                :reduce="zone => zone"
                label="name"
              >
                <template #option="{ name }">
                  {{ name }}
                </template>
                <template #selected-option="{ name }">
                  {{ name }}
                </template>
              </v-select> -->
            </div>
            <div class="form-floating">
              <input
                v-model="user.password"
                :type="passwordType"
                class="form-control"
                id="password"
                placeholder="Password"
              />
              <div
                class="toggle"
                v-html="passwordType === 'password' ? eyeOff : eyeOn"
                @click="togglePassword"
              ></div>
              <label for="password">Password</label>
              <div class="invalid-feedback">Password must be at least 8 characters long.</div>
            </div>
          </div>

          <div v-if="user.step === 3" class="form-footer">
            <div class="d-grid">
              <button
                :disabled="isButtonDisabled"
                @click="user.step = 4"
                class="btn btn-primary"
                type="button"
              >
                <div>
                  <span v-if="isLoading"></span>
                  Next
                </div>
              </button>
            </div>
          </div>

          <div v-if="user.step === 4" class="form-footer">
            <div class="d-flex">
              <button
                :disabled="isButtonDisabled"
                @click="user.step = 3"
                class="btn btn-primary"
                type="button"
              >
                <div>
                  Back
                </div>
              </button>

              <button :disabled="isLoading" class="btn btn-primary" type="submit">
                <div>
                  <div v-if="isLoading" class="spinner-border" role="status">
                    <span class="visually-hidden">Loading...</span>
                  </div>
                  Register
                </div>
              </button>
            </div>
          </div>
        </form>
      </div>
    </section>
    <FooterNew />
  </div>
</template>
<script>
import axios from 'axios';
import carousel from 'vue-owl-carousel';
import { mapGetters, mapActions } from 'vuex';
import { BRANDS } from '../../constants';
import FooterNew from './FooterNew.vue';
import titleMixin from '../../mixins/titleMixin';
import { TIME_ZONES } from '../../constants';
import debounce from 'lodash/debounce';

export default {
  mixins: [titleMixin],
  title() {
    return 'Employer Sign Up | Jobshark';
  },
  data: () => ({
    citiesPage: 1,
    citiesLastPage: 1,
    loadingMore: false,
    newCountryList: [],
    newCityList: [],
    currentYear: new Date().getFullYear(),
    brands: BRANDS,
    isLoading: false,
    submitsUsed: 0,
    cooldownRemaining: 0,
    cooldownTimer: null,
    reToken: '',
    user: {
      step: 1,
      company: '',
      countryCode: 'Sweden',
      phone: '+46 ',
      timeZone: {
        id: 358,
        utc_timezone: '(UTC +02:00) Europe/Stockholm',
        time_zone: 'Europe/Stockholm',
      },
      email: '',
      privacy: false,
      address: '',
      code: '',
      firstName: '',
      lastName: '',
      postal: '',
      city: '',
      country: { id: 213, name: 'Sweden', phone_code: '+46', source: 'system', part_of_eu: 1 },
      password: '',
      campaign_id: null,
      campaign_medium: null,
      campaign_name: null,
      campaign_source: null,
    },

    timeZone: '',
    tzOptions: [],
    tzPage: 1,
    tzLastPage: 1,
    tzSearch: '',
    tzLoading: false,
    tzSearchTimeout: null,
    eyeOff: `<svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 24" fill="none">
  <g clip-path="url(#clip0_2763_7769)">
    <path d="M18.44 17.9337C16.7306 19.2367 14.6491 19.9585 12.5 19.9937C5.5 19.9937 1.5 11.9937 1.5 11.9937C2.74389 9.67557 4.46914 7.65029 6.56 6.05368M10.4 4.23368C11.0883 4.07256 11.7931 3.99202 12.5 3.99368C19.5 3.99368 23.5 11.9937 23.5 11.9937C22.893 13.1293 22.1691 14.1984 21.34 15.1837M14.62 14.1137C14.3454 14.4084 14.0141 14.6448 13.6462 14.8088C13.2782 14.9728 12.8809 15.0609 12.4781 15.068C12.0753 15.0752 11.6752 15.0011 11.3016 14.8502C10.9281 14.6993 10.5887 14.4747 10.3038 14.1898C10.019 13.905 9.79439 13.5656 9.64351 13.1921C9.49262 12.8185 9.41853 12.4184 9.42563 12.0156C9.43274 11.6128 9.52091 11.2155 9.68488 10.8475C9.84884 10.4795 10.0853 10.1483 10.38 9.87368" stroke="#8A7C73" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M1.5 0.993652L23.5 22.9937" stroke="#8A7C73" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </g>
  <defs>
    <clipPath id="clip0_2763_7769">
      <rect width="24" height="24" fill="white" transform="translate(0.5 -0.00634766)"/>
    </clipPath>
  </defs>
</svg>`,
    eyeOn: `<svg width="25" height="25" viewBox="0 0 25 18" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M18.44 14.9322C16.7306 16.2352 14.6491 16.9571 12.5 16.9922C5.5 16.9922 1.5 8.99221 1.5 8.99221C2.74389 6.67411 4.46914 4.64882 6.56 3.05221M10.4 1.23221C11.0883 1.07109 11.7931 0.990551 12.5 0.992213C19.5 0.992213 23.5 8.99221 23.5 8.99221C22.893 10.1278 22.1691 11.1969 21.34 12.1822M14.62 11.1122C14.3454 11.407 14.0141 11.6434 13.6462 11.8073C13.2782 11.9713 12.8809 12.0595 12.4781 12.0666C12.0753 12.0737 11.6752 11.9996 11.3016 11.8487C10.9281 11.6978 10.5887 11.4732 10.3038 11.1884C10.019 10.9035 9.79439 10.5642 9.64351 10.1906C9.49262 9.81705 9.41853 9.41693 9.42563 9.01412C9.43274 8.61131 9.52091 8.21406 9.68488 7.84606C9.84884 7.47806 10.0853 7.14686 10.38 6.87221" stroke="#8A7C73" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`,
    passwordType: 'password',
  }),
  components: {
    carousel,
    FooterNew,
  },

  methods: {
    ...mapActions(['retrieveCitiesListByCountryId']),

    fetchTimezones(reset = false) {
      if (this.tzLoading) return;
      if (!reset && this.tzPage > this.tzLastPage) return;
      this.tzLoading = true;
      if (reset) {
        this.tzPage = 1;
        this.tzLastPage = 1;
      }
      axios(`${process.env.VUE_APP_API_URL}/common/timezone/all`, {
        method: 'post',
        data: { page: this.tzPage, count: 50, search_word: this.tzSearch },
        headers: {
          Authorization: `Bearer ${localStorage.getItem(
            `${process.env.VUE_APP_TOKEN_PREFIX}token`,
          )}`,
          Accept: 'application/json',
        },
      })
        .then(res => {
          const raw = res.data.data !== undefined ? res.data.data : res.data;
          const items = Array.isArray(raw) ? raw : Object.values(raw);
          if (reset) {
            this.tzOptions = items;
          } else {
            const dropdown = this.$refs.tzSelect.$refs.dropdownMenu;
            const scrollTop = dropdown ? dropdown.scrollTop : 0;
            items.forEach(item => this.tzOptions.push(item));
            this.$nextTick(() => {
              if (dropdown) dropdown.scrollTop = scrollTop;
            });
          }
          this.tzLastPage = res.data.last_page;
          this.tzPage += 1;
        })
        .catch(() => {})
        .finally(() => {
          this.tzLoading = false;
        });
    },
    onTzSearch(search) {
      clearTimeout(this.tzSearchTimeout);
      this.tzSearchTimeout = setTimeout(() => {
        this.tzSearch = search;
        this.fetchTimezones(true);
      }, 300);
    },
    onTzOpen() {
      this.$nextTick(() => {
        const dropdown = this.$refs.tzSelect.$refs.dropdownMenu;
        if (!dropdown) return;
        dropdown.addEventListener('scroll', this.onTzScroll);
      });
    },
    onTzScroll(e) {
      const el = e.target;
      if (this.tzPage > this.tzLastPage) return;
      if (this.tzLoading) return;
      if (el.scrollTop + el.clientHeight >= el.scrollHeight - 20) {
        this.fetchTimezones();
      }
    },

    /*     customFilter(options, search) {
      if (!search) return options;

      return options
        .filter(option => {
          const label = option.name || option.label || option;
          return label.toLowerCase().includes(search.toLowerCase());
        })
        .sort((a, b) => {
          const aLabel = a.name || a.label || a;
          const bLabel = b.name || b.label || b;

          // Exact match at start gets highest priority
          const aStartsWith = aLabel.toLowerCase().startsWith(search.toLowerCase());
          const bStartsWith = bLabel.toLowerCase().startsWith(search.toLowerCase());

          if (aStartsWith && !bStartsWith) return -1;
          if (!aStartsWith && bStartsWith) return 1;

          // Then sort by length (shorter matches first)
          return aLabel.length - bLabel.length;
        });
    }, */

    getCaptcha(status) {
      if (!this.validateEmail(this.user.email)) {
        this.$toasted.error('Enter a valid email address.', {
          theme: 'bubble',
          position: 'bottom-right',
          duration: 5000,
        });
        return;
      }
      if (!this.user.privacy) {
        this.$toasted.error(
          `Please agree to Jobshark's Integrity Policy and User conditions to register.`,
          {
            theme: 'bubble',
            position: 'bottom-right',
            duration: 5000,
          },
        );
        return;
      }
      let vm = this;
      const SIGNIN = () => this.registerEmail(status);
      grecaptcha
        .execute('6LdTF5MqAAAAACaGiGhB9RJdrmDU9mcatUuj1vom', { action: 'register' })
        .then(function(token) {
          vm.reToken = token;
          SIGNIN();
        });
    },

    registerEmail(status) {
      if (this.isLoading) return;
      this.isLoading = true;
      axios
        .post(`${process.env.VUE_APP_API_URL}/manager/auth/register`, {
          email: this.user.email,
          privacy: this.user.privacy,
          'g-recaptcha-response': this.reToken,
        })
        .then(() => {
          if (this.user.step === 1) {
            this.user.step++;
          }
          if (status === 21) {
            this.$toasted.success('New verification code was sent to your email address.', {
              theme: 'bubble',
              position: 'bottom-right',
              duration: 5000,
            });
          }
          this.isLoading = false;
        })
        .catch(err => {
          this.isLoading = false;
          if (err.response) {
            if (err.response.status === 429) {
              this.$toasted.error(
                'Too many attempts. This operation is temporarily blocked for 10 minutes.',
                {
                  theme: 'bubble',
                  position: 'bottom-right',
                  duration: 5000,
                },
              );
              return;
            }
            if (err.response.data.internal_code && err.response.data.internal_code === 5000) {
              this.$toasted.error('Invalid email address', {
                theme: 'bubble',
                position: 'bottom-right',
                duration: 5000,
              });
              return;
            }
            const errorMessage = err.response.data.message;
            if (errorMessage === 'The email has already been taken.') {
              this.$toasted.error(
                'A user with this email address already exists. Try to log in instead',
                {
                  theme: 'bubble',
                  position: 'bottom-right',
                  duration: 5000,
                },
              );
            } else if (errorMessage === 'Temporary and personal email addresses are not allowed.') {
              this.$toasted.error('Please enter a valid corporate email address', {
                theme: 'bubble',
                position: 'bottom-right',
                duration: 5000,
              });
            } else if (errorMessage === 'The email must be a valid email address.') {
              this.$toasted.error('Invalid email address', {
                theme: 'bubble',
                position: 'bottom-right',
                duration: 5000,
              });
            } else {
              const errors =
                err.response && err.response.data && err.response.data.errors
                  ? err.response.data.errors
                  : null;

              if (errors && typeof errors === 'object') {
                const values = Object.values(errors); // ex: [ ["msg1", "msg2"] ]
                const firstFieldErrors = values.length ? values[0] : null;
                const firstMessage =
                  firstFieldErrors && firstFieldErrors.length ? firstFieldErrors[0] : null;

                if (firstMessage) {
                  this.$toasted.error(firstMessage, {
                    theme: 'bubble',
                    position: 'bottom-right',
                    duration: 5000,
                  });
                  return;
                }
              }

              this.$toasted.error('Invalid email address', {
                theme: 'bubble',
                position: 'bottom-right',
                duration: 5000,
              });
            }
          }
        });
    },

    verifyEmail() {
      this.isLoading = true;
      axios
        .post(`${process.env.VUE_APP_API_URL}/manager/auth/verifyemail`, {
          email: this.user.email,
          code: this.user.code.toString(),
        })
        .then(() => {
          this.user.step++;
          this.isLoading = false;
        })
        .catch(err => {
          this.isLoading = false;
          if (err.response) {
            if (err.response.status === 429) {
              this.$toasted.error(
                'Too many attempts. This operation is temporarily blocked for 10 minutes.',
                {
                  theme: 'bubble',
                  position: 'bottom-right',
                  duration: 5000,
                },
              );
              return;
            }
          }
          this.$toasted.error('Incorrect verification code.', {
            theme: 'bubble',
            position: 'bottom-right',
            duration: 5000,
          });
        });
    },

    async completeProfile() {
      if (!this.validateFields()) {
        return;
      }
      try {
        const payload = {
          company_name: this.user.company,
          email: this.user.email,
          password: this.user.password,
          first_name: this.user.firstName,
          last_name: this.user.lastName,
          city_id: this.user.city.id,
          country_id: this.user.country.id,
          postal_code: this.user.postal,
          street_address: this.user.address,
          timezone_id: this.user.timeZone.id,
          country_code: this.user.countryCode,
          phone_number: this.user.phone,
          campaign_id: this.user.campaign_id,
          campaign_medium: this.user.campaign_medium,
          campaign_name: this.user.campaign_name,
          campaign_source: this.user.campaign_source,
        };

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'conversion_event_signup', // Matches the event name in GTM
          event_label_company: this.user.company,
          event_label_email: this.user.email,
        });

        const response = await this.$store.dispatch('completeProfile', payload);
        this.$router.push({ name: 'manager-jobs' });
      } catch (error) {
        console.error('Error completing profile:', error);

        this.$toasted.error(errorService(error), {
          theme: 'bubble',
          position: 'bottom-right',
          duration: 5000,
        });
      }
    },

    validateFields() {
      let isValid = true;

      const requiredFields = [
        { field: 'firstName', value: this.user.firstName, id: 'first-name' },
        { field: 'lastName', value: this.user.lastName, id: 'last-name' },
        { field: 'countryCode', value: this.user.countryCode, id: 'country-code' },
        { field: 'phone', value: this.user.phone, id: 'phone' },
        { field: 'password', value: this.user.password, id: 'password' },
        // Removed website from required fields
      ];

      // Validate each required field
      requiredFields.forEach(({ value, id, field }) => {
        const inputElement = document.getElementById(id);

        // For password, check both existence and length
        if (field === 'password') {
          if (!value || value.length < 8) {
            inputElement.classList.add('is-invalid');
            isValid = false;
          } else {
            inputElement.classList.remove('is-invalid');
          }
        } else if (!value || (typeof value === 'object' && !value.id)) {
          // For other fields, check for value or object.id
          inputElement.classList.add('is-invalid');
          isValid = false;
        } else {
          inputElement.classList.remove('is-invalid');
        }
      });

      return isValid;
    },

    togglePassword() {
      this.passwordType = this.passwordType === 'password' ? 'text' : 'password';
    },
    fetchCitisByCountryId(e) {
      this.user.city = '';
      this.debouncedGetCities('', this.user.country.id);
      this.user.countryCode = this.user.country.name;
      this.user.phone = this.user.country.phone_code + ' ';
      this.citiesPage = 1;
    },
    fetchCitisByCountryIdInitial(e) {
      this.getCitiesList();
      this.user.countryCode = this.user.country.name;
    },

    addCountryCode(code) {
      if (code) {
        const match = code.match(/^(\+\d+)\s(.+)$/);
        if (match) {
          this.user.phone = match[1] + ' ';
          this.user.countryCode = match[2];
        } else {
          console.error('Invalid format for country code and name.');
        }
      }
    },

    sendNewCode() {
      this.getCaptcha(21);
      this.user.code = '';
      this.$toasted.success('New verification code was sent to your email address.', {
        theme: 'bubble',
        position: 'bottom-right',
        duration: 5000,
      });
    },

    resetSearch() {
      this.citiesPage = 1;
    },

    changeEmail() {
      this.user.step = 1;
      this.user.code = '';
    },

    validateEmail(email) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(email);
    },

    fetchCountries(searchText) {
      this.debouncedGetCountries(searchText);
    },

    fetchCities(searchText) {
      this.citiesPage = 1;
      this.debouncedGetCities(searchText);
    },

    getCountriesList(name) {
      axios
        .post(`${process.env.VUE_APP_API_URL}/common/address/searchcountry`, {
          search_word: name ? name : '',
          page: 1,
          count: 250,
        })
        .then(res => {
          this.newCountryList = res.data.data;
        })
        .catch(err => {
          console.log(err);
        });
    },

    getCitiesList(name, id) {
      axios
        .post(`${process.env.VUE_APP_API_URL}/common/address/searchcity`, {
          country_id: this.user.country.id,
          search_word: name ? name : '',
          page: 1,
          count: 150,
        })
        .then(res => {
          this.newCityList = res.data.data;
          this.citiesLastPage = res.data.last_page;
        })
        .catch(err => {
          console.log(err);
        });
    },

    SearchCityByScroll(name, id) {
      axios
        .post(`${process.env.VUE_APP_API_URL}/common/address/searchcity`, {
          country_id: this.user.country.id,
          search_word: name ? name : '',
          page: this.citiesPage,
          count: 150,
        })
        .then(res => {
          const newItems = res.data.data;
          this.citiesLastPage = res.data.last_page;
          // merge + remove duplicates by ID
          const merged = [...this.newCityList, ...newItems];

          // dedupe by ID (fixes duplicate key warnings)
          const unique = merged.filter(
            (item, index, self) => index === self.findIndex(t => t.id === item.id),
          );

          this.newCityList = unique;

          this.loadingMore = false;
        })
        .catch(err => {
          console.log(err);
        });
    },

    getDefaultCountry() {
      axios
        .get(`${process.env.VUE_APP_API_URL}/common/address/getaddressbyip`, {
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
        })
        .then(res => {
          if (res.data.city_id !== null) {
            const {
              city_id,
              city_name,
              city_postal_code,
              country_id,
              country_name,
              phone_code,
              time_zone,
            } = res.data;
            this.user.country = {
              id: country_id,
              name: country_name,
              phone_code: phone_code,
              source: 'system',
            };
            this.user.city = {
              country_id: country_id,
              id: city_id,
              name: city_name,
            };
            this.user.phone = phone_code + ' ';
            if (city_postal_code !== null) {
              this.user.postal = city_postal_code;
            }
            this.fetchCitisByCountryIdInitial(country_id);

            this.user.timeZone = time_zone;
          }
        })
        .catch(err => {
          console.log(err);
        });
    },

    getCampainParams() {
      if (this.$route.query.utm_id) {
        this.user.campaign_id = this.$route.query.utm_id;
      }
      if (this.$route.query.utm_medium) {
        this.user.campaign_medium = this.$route.query.utm_medium;
      }
      if (this.$route.query.utm_campaign) {
        this.user.campaign_name = this.$route.query.utm_campaign;
      }
      if (this.$route.query.utm_source) {
        this.user.campaign_source = this.$route.query.utm_source;
      }
    },

    onSelectOpen() {
      // Wait for DOM
      this.$nextTick(() => {
        const dropdown = this.$refs.citySelect.$refs.dropdownMenu;
        if (!dropdown) return;

        // attach scroll listener only once
        dropdown.addEventListener('scroll', this.handleScroll);
      });
    },

    handleScroll(e) {
      const el = e.target;
      // detect near bottom
      const reachedBottom = el.scrollTop + el.clientHeight >= el.scrollHeight - 20;
      if (this.citiesPage >= this.citiesLastPage) return;
      if (reachedBottom && !this.loadingMore) {
        this.loadingMore = true;
        this.citiesPage++;
        this.SearchCityByScroll();
      }
    },

    startCooldown(seconds = 30) {
      // reset any existing timer
      if (this.cooldownTimer) clearInterval(this.cooldownTimer);

      this.cooldownRemaining = seconds;

      this.cooldownTimer = setInterval(() => {
        this.cooldownRemaining -= 1;
        if (this.cooldownRemaining <= 0) {
          this.cooldownRemaining = 0;
          clearInterval(this.cooldownTimer);
          this.cooldownTimer = null;
        }
      }, 1000);
    },
  },
  computed: {
    ...mapGetters(['getCitiesListByCountry', 'getAllCountries']),

    isSubmitDisabled() {
      return this.isLoading || this.cooldownRemaining > 0 || this.submitsUsed >= 2;
    },

    isButtonDisabled() {
      return (
        !this.user.company ||
        !this.user.address ||
        !this.user.postal ||
        !this.user.city ||
        !this.user.country
      );
    },

    formattedCountries() {
      return this.getAllCountries.map(item => `${item.phone_code} ${item.name}`);
    },

    getTimeZones() {
      return TIME_ZONES;
    },
  },
  created() {
    this.debouncedGetCountries = debounce(name => {
      this.getCountriesList(name);
    }, 500);

    this.debouncedGetCities = debounce((name, id) => {
      this.getCitiesList(name, id);
    }, 500);
  },
  mounted() {
    this.retrieveCitiesListByCountryId({ id: this.user.country.id });
    this.getCampainParams();
    this.getDefaultCountry();
    this.getCountriesList();
    this.fetchTimezones(true);
  },

  beforeDestroy() {
    if (this.cooldownTimer) clearInterval(this.cooldownTimer);
  },
};
</script>
<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,100..1000;1,9..40,100..1000&family=Lato:ital,wght@0,100;0,300;0,400;0,700;0,900;1,100;1,300;1,400;1,700;1,900&display=swap');

.form-floating {
  label {
    left: 0px;
  }
}
.form-check-input:checked {
  background-color: #f05c00;
  border-color: #f05c00;
}
section {
  font-family: 'Lato', serif !important;
  display: flex;
  min-height: calc(100vh - 66px);
  position: relative;
  .content {
    width: 50%;
    .header {
      position: relative;
      background: #000;
      text-align: center;
      width: 100%;
      padding: 40px 0;
      align-self: flex-start;
      h1 {
        color: #fff !important;
        font-family: 'DM Sans', sans-serif !important;
        font-size: 64px !important;
        letter-spacing: 2px;
      }
      .triangles {
        position: absolute;
        bottom: 0;
        left: 50px;
      }
      .trianglesTwo {
        position: absolute;
        top: 0;
        right: -80px;
      }
    }
    .list-content {
      padding: 73px 0px;
      width: 58%;
      margin: 0 auto;
      h4 {
        margin-bottom: 30px;
        font-weight: 600;
      }
      .list-unstyled {
        li {
          margin-bottom: 16px;
          display: flex;
          svg {
            margin-right: 16px;
            flex-shrink: 0;
            margin-top: 3px;
          }
        }
      }
    }
    .logos {
      width: 100%;
      h5 {
        text-align: center;
        margin-bottom: 24px;
      }
      .carousel {
        background-color: #f5f5f5;
        padding: 34px 96px;
      }
      img {
        filter: grayscale(100%);
        &:hover {
          filter: grayscale(0);
        }
      }
    }
    &:first-of-type {
      background: #fff;
    }
  }
  .content-form {
    display: flex;
    justify-content: center;
    width: 50%;
    background: #f5f5f5;
    padding-top: 80px;
    padding-bottom: 60px;
    .form {
      width: 48%;
      .title {
        text-align: center;
        .svg-icon {
          width: 96px;
          height: auto;
          display: block;
          margin: 0 auto 30px auto;
        }
        h3 {
          letter-spacing: 2px;
          margin-bottom: 48px;
        }
        span {
          font-size: 14px;
          color: #82746c;
          position: relative;
          display: inline-block;
          margin-bottom: 48px;
          &::before {
            content: '';
            position: absolute;
            top: 12px;
            left: -104px;
            width: 80px;
            height: 1px;
            background-color: #82746c;
            opacity: 0.4;
          }
          &::after {
            content: '';
            position: absolute;
            top: 12px;
            right: -104px;
            width: 80px;
            height: 1px;
            background-color: #82746c;
            opacity: 0.4;
          }
        }
      }
      .form-floating {
        position: relative;
        margin-bottom: 21px;
        label {
          font-size: 16px;
          color: #685d56;
        }
        .form-control {
          border-radius: 0;
          height: 48px;
        }
        .toggle {
          position: absolute;
          top: 50%;
          transform: translate(0, -50%);
          right: 15px;
          cursor: pointer;
        }
        &.required {
          &::after {
            content: '*';
            position: absolute;
            color: red;
            top: 0;
            right: 8px;
            height: 100%;
            padding-top: 8px;
            display: flex;
            align-items: center;
            font-size: 24px;
            line-height: 0;
          }
        }
      }
      .select-model {
        position: relative;
        &::after {
          content: '*';
          position: absolute;
          color: red;
          top: 0;
          right: 8px;
          height: 100%;
          padding-top: 8px;
          display: flex;
          align-items: center;
          font-size: 24px;
          line-height: 0;
        }
      }
      .form-check {
        font-size: 14px;
      }
      .form-footer {
        margin-top: 48px;
        .d-flex {
          justify-content: space-between;
          gap: 24px;
          .btn {
            flex: 1;
            &:first-of-type {
              background: #f05c00 !important;
              border-color: #f05c00 !important;
            }
          }
        }
        .btn {
          background: #000 !important;
          border-color: #000 !important;
          height: 50px;
          div {
            position: relative;
            display: inline-block;
            .spinner-border {
              position: absolute;
              width: 1.4rem;
              height: 1.4rem;
              left: -30px;
              color: #f05c00;
            }
          }
        }
        .contact {
          text-align: center;
          margin-top: 48px;
          span {
            display: inline-block;
            margin-bottom: 8px;
            font-weight: 400;
            font-size: 18px;
            &:first-of-type {
              margin-right: 23px;
            }
            &:nth-of-type(2) {
              text-decoration: underline;
              cursor: pointer;
              font-weight: 600;
            }
          }
          .account {
            font-size: 18px;
            a {
              color: #08c;
              font-size: 18px;
              margin-left: 23px;
              text-decoration: underline;
              cursor: pointer;
            }
          }
        }
        .new-code {
          text-align: center;
          margin-top: 18px;
          font-size: 18px;
          span {
            color: #08c;
            font-size: 15px;
            font-weight: 500;
            cursor: pointer;
            &:hover {
              text-decoration: underline;
            }
            &:nth-of-type(2) {
              margin-left: 12px;
            }
          }
        }
      }
    }
  }
}

@media (max-width: 1024px) {
  section {
    flex-wrap: wrap;
    overflow-x: hidden;
    .content {
      width: 100%;
      order: 2;
      padding-bottom: 80px;
      .list-content {
        width: 100%;
        padding-left: 25px;
        padding-right: 25px;
      }
      .header {
        .trianglesTwo {
          right: -120px;
          top: 50px;
        }
      }
      .logos {
        h5 {
          padding: 0 25px;
        }
      }
    }
    .content-form {
      width: 100%;
      padding-left: 35px;
      padding-right: 35px;
      padding-bottom: 80px;
      .form {
        width: 65%;
      }
    }
  }
}

@media (max-width: 768px) {
  section {
    flex-wrap: wrap;
    overflow-x: hidden;
    .content {
      width: 100%;
      order: 2;
      padding-bottom: 80px;
      .list-content {
        width: 100%;
        padding-left: 35px;
        padding-right: 35px;
      }
      .header {
        .trianglesTwo {
          right: -120px;
          top: 50px;
        }
      }
      .logos {
        h5 {
          padding: 0 25px;
        }
      }
    }
    .content-form {
      width: 100%;
      padding-left: 25px;
      padding-right: 25px;
      padding-bottom: 80px;
      .form {
        width: 100%;
      }
    }
  }
}
</style>
